(function () {
  if (window.MPSCollectionFitmentLoader) return;

  function getProductKey(item) {
    var productLink = item.querySelector('a[href*="/products/"]');
    if (productLink) {
      return productLink.href.split('?')[0].split('#')[0];
    }

    return (item.getAttribute('data-search-text') || item.textContent || '').trim();
  }

  function pageUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', page);
    return url.toString();
  }

  function appendGridItems(targetGrid, sourceGrid) {
    if (!targetGrid || !sourceGrid) return 0;

    var known = {};
    Array.prototype.forEach.call(targetGrid.querySelectorAll('[data-search-item]'), function (item) {
      known[getProductKey(item)] = true;
    });

    var added = 0;
    // Universal parts sit at the end of the grid; bike parts from other pages go before them
    var firstUniversal = targetGrid.querySelector('[data-mps-universal-item]');
    Array.prototype.forEach.call(sourceGrid.querySelectorAll('[data-search-item]'), function (item) {
      var key = getProductKey(item);
      if (!key || known[key]) return;

      var clone = document.importNode(item, true);
      clone.hidden = true;
      clone.setAttribute('data-mps-fitment-clone', '');
      if (firstUniversal && !clone.hasAttribute('data-mps-universal-item')) {
        targetGrid.insertBefore(clone, firstUniversal);
      } else {
        targetGrid.appendChild(clone);
      }
      known[key] = true;
      added += 1;
    });

    return added;
  }

  function ensureAllPagesLoaded(results) {
    if (!results) return Promise.resolve(0);

    var grid = results.querySelector('[data-mps-fitment-grid]');
    if (!grid) return Promise.resolve(0);

    var totalPages = Number(grid.getAttribute('data-mps-fitment-pages') || 1);
    if (totalPages <= 1 || grid.getAttribute('data-mps-fitment-loaded') === 'true') {
      return Promise.resolve(0);
    }

    if (grid.mpsFitmentLoadingPromise) {
      return grid.mpsFitmentLoadingPromise;
    }

    grid.mpsFitmentLoadingPromise = Promise.all(
      Array.from({ length: totalPages - 1 }, function (_, index) {
        var page = index + 2;
        return fetch(pageUrl(page), { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) return 0;
            return response.text();
          })
          .then(function (html) {
            if (!html) return 0;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return appendGridItems(grid, doc.querySelector('[data-mps-fitment-grid]'));
          })
          .catch(function () {
            return 0;
          });
      })
    ).then(function (counts) {
      grid.setAttribute('data-mps-fitment-loaded', 'true');
      return counts.reduce(function (total, count) {
        return total + count;
      }, 0);
    });

    return grid.mpsFitmentLoadingPromise;
  }

  window.MPSCollectionFitmentLoader = {
    ensureAllPagesLoaded: ensureAllPagesLoaded
  };
})();
